import { useContext } from 'react';
import AudioSeekContext from '@/contexts/audio-playback/audio-seek';

const useLiveAudioSeek = () => {
  const {
    seek,
    handleSeek,
    handleSeekBackward15Seconds,
    handleSeekForward15Seconds
  } = useContext(AudioSeekContext);

  return {
    liveSeek: seek,
    handleSeek,
    handleSeekBackward15Seconds,
    handleSeekForward15Seconds
  };
};

export default useLiveAudioSeek;